<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="dialogVisible"
    :title="snDetailsEdit.pkid ? '编辑' : '新建'"
    append-to-body
    width="600px"
    :close-on-click-modal="false"
    @close="closeHandle"
  >
    <el-form ref="form" :model="snDetailsEdit" :rules="ruleValidate" class="form" label-width="80px">
      <el-row>
        <el-col>
          <el-form-item label="标签编号" prop="metaDataNo">
            <el-input v-model="snDetailsEdit.metaDataNo" readonly placeholder="请选择标签">
              <el-button slot="append" @click="$refs.selectMetaData.open()" icon="el-icon-search"></el-button>
            </el-input>
            <mate-data-lable-select ref="selectMetaData" @select="selectMetaData" />
          </el-form-item>
        </el-col>
        <el-col v-if="snDetailsEdit.metaDataNo">
          <el-form-item label="标签描述" prop="metaDataDesc">
            <el-input v-model="snDetailsEdit.metaDataDesc" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="标签值" prop="metaDataValue">
        <el-input v-model="snDetailsEdit.metaDataValue" placeholder="请输入标签值" />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import MateDataLableSelect from "@/views/information/MaterialSnRule/MateDataLableSelect";
export default {
  components: { MateDataLableSelect },
  data() {
    return {
      dialogVisible: false,
      snDetailsEdit: {
        metaDataNo: "",
        metaDataId: "",
        metaDataValue: "",
        metaDataDesc: "",
      },
      ruleValidate: {
        metaDataNo: { required: true, message: "请选择标签", trigger: "blur" },
        metaDataValue: { required: true, message: "标签值不能为空", trigger: "blur" },
      },
    };
  },
  methods: {
    open() {
      this.dialogVisible = true;
    },

    // 选择标签
    selectMetaData(row) {
      this.snDetailsEdit.metaDataNo = row.metaDataNo;
      this.snDetailsEdit.metaDataId = row.pkid;
      this.snDetailsEdit.metaDataDesc = row.metaDataDesc;
    },

    // 提交
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit("save-success", this.snDetailsEdit);
          this.dialogVisible = false;
        }
      });
    },

    closeHandle() {
      this.snDetailsEdit = {
        metaDataNo: "",
        metaDataId: "",
        metaDataValue: "",
        metaDataDesc: "",
      };
    },
  },
};
</script>
